'use strict';

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol['for'] && Symbol['for']("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactDom = require('react-dom');

var _reactDom2 = _interopRequireDefault(_reactDom);

var _baseForm = require('common/components/base-form');

var _baseForm2 = _interopRequireDefault(_baseForm);

var _hfReactHelper = require('common/utils/hf-react-helper');

var _hfReactHelper2 = _interopRequireDefault(_hfReactHelper);

var _button = require('common/components/button');

var _button2 = _interopRequireDefault(_button);

var _passwordRecoveryResponse = require('./password-recovery-response');

var _passwordRecoveryResponse2 = _interopRequireDefault(_passwordRecoveryResponse);

var _setTimeout = require('common/utils/set-timeout');

var _setTimeout2 = _interopRequireDefault(_setTimeout);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

/**
 * NOTE: This form is a good example of how to use
 * Symfony and React forms together
 */
var ForgotPasswordForm = _baseForm2['default'].createFormClass({

    displayName: 'ForgotPasswordForm',

    propTypes: {
        'tabOffset': _react2['default'].PropTypes.number,
        'emailAddress': _react2['default'].PropTypes.string
    },

    getInitialState: function getInitialState() {
        return {
            emailAddress: this.props.emailAddress
        };
    },

    componentDidMount: function componentDidMount() {
        var root = $(_reactDom2['default'].findDOMNode(this));
        (0, _setTimeout2['default'])(function () {
            root.find('input').focus();
        }, 500);
    },

    onEmailChange: function onEmailChange(event) {
        this.setState({ 'emailAddress': event.target.value.trim() });
    },

    onSubmit: function onSubmit(evt) {

        evt.preventDefault();

        // Validate email
        if (!_hfReactHelper2['default'].isValidEmailAddress(this.state.emailAddress)) {
            this.setState({
                'errors': { 'named': { 'email_address': 'Please enter a valid email address' } },
                'hasErrors': true
            });
            return;
        }

        this.setState({
            'errors': null,
            'hasErrors': false
        });

        var root = $(_reactDom2['default'].findDOMNode(this));

        this.submitAsync(function (resp) {

            root.closest('.reveal-modal').foundation('reveal', 'close');
            var attachPoint = _hfReactHelper2['default'].getRevealAttachPoint('password_recovery_success', 'tiny');
            _reactDom2['default'].render(_jsx(_passwordRecoveryResponse2['default'], {
                isSuccessful: resp.success
            }, void 0), attachPoint);
        });
    },

    render: function render() {

        var tabOffset = parseInt(this.props.tabOffset || 0, 10);

        var inputField = this.renderField('email_address', {
            'tabIndex': tabOffset + 1,
            'className': 'm-modal--text-input',
            'placeholder': 'Email',
            'data-format': 'email',
            'onChange': this.onEmailChange,
            'value': this.state.emailAddress
        });

        return _jsx('form', {}, void 0, inputField, this.renderHiddenFields(), _jsx('div', {
            className: 'm-modal--error'
        }, void 0, this.renderErrorText()), _jsx(_button2['default'], {
            buttonText: 'Reset Password',
            buttonTabIndex: tabOffset + 2,
            onClick: this.onSubmit,
            buttonColor: 'grasshopper'
        }));
    }
});

module.exports = ForgotPasswordForm;


/*****************
 ** WEBPACK FOOTER
 ** ./src/hellosign/components/auth/forgot-password-form.jsx
 ** module id = 755
 ** module chunks = 0
 **/